// @ts-nocheck
import { alpha, createTheme } from '@mui/material/styles';
import _ from 'lodash';
import baseTheme from './base';

// NOTE: Do not use any const or let in the theme file. It will break the theme object.

const DARK_THEME = {
  themeName: 'Nimbus Dark',
  palette: {
    mode: 'dark',
    type: 'dark',
    primary: {
      main: '#F7F7F7',
      dark: '#FFFFFF',
      contrastText: '#3B3B3B',
    },
    secondary: {
      main: '#464C64',
      contrastText: '#FFFFFF',
      light: '#8B96DE',
    },
    error: {
      main: '#F44336', // Red 500 - WCAG AA compliant
      light: '#E57373', // Red 300
      dark: '#D32F2F', // Red 700
      contrastText: '#FFFFFF', // White text - passes WCAG AAA
    },
    success: {
      main: '#4CAF50', // Green 500 - WCAG AA compliant
      light: '#81C784', // Green 300
      dark: '#388E3C', // Green 700
      contrastText: '#FFFFFF', // White text - passes WCAG AAA
      successTask: '#66BB6A', // Green 400
    },
    warning: {
      main: '#ED6C02', // Orange 600 - WCAG AA compliant
      light: '#FFB74D', // Orange 300
      dark: '#E65100', // Orange 900
      contrastText: '#FFFFFF', // White text - passes WCAG AAA
    },
    info: {
      main: '#29B6F6', // Light Blue 400 - WCAG AA compliant
      light: '#4FC3F7', // Light Blue 300
      dark: '#0288D1', // Light Blue 700
      contrastText: '#000000', // Black text for better contrast
    },
    background: {
      default: '#13141A',
      paper: '#1A1B22',
    },
    divider: '#ebebeb',
    other: {
      multipleSnackBarBg: '#3A3D54',
      listTableRowSelectedBg: '#353846',
      sidebar: '#292c35',
      sidebarMenuHover: '#353846',
      sidebarMenuSelected: '#3D4256',
      navbar: '#2E3037',
      menuItemColor: '#292c35',
      menuBackground: '#090f19',
      loaderBackground: '#F7F7F7',
      subHeading: '#3D4256',
      icon: '#ffffff',
      groupHeading: '#3B3B3B',
      lightGreen: '#ECFDF3',
      green1: '#3cf4ff',
      lightRed: '#FEF3F2',
      lightGreen1: '#12B76A',
      lightRed1: '#F04438',
      lightGreen2: '#027A48',
      lightRed2: '#B42318',

      listTableHeaderBg: 'transparent',
      outlineColor: '#FFFF',

      blue1: '#3B3B3B',
      blue2: '#F3F5FF',
      blue8: '#3A3D54',
      lightBrandBlueLogin: '#1A1B22',
      hover: '#E8F1FF',
      white: '#FFFFFF',
      white2: '#ddd',
      black: '#000000',
      grey1: '#3D4256',
      grey2: '#9396AA',
      gray3: '#E5E8FA',
      purple: '#963DEE',
      grey6: '#636363',
      grey8: '#8F8F8F',
      lightGrey: '#3D4251',
      red: '#FF1809',
      tableCell: '#13141A',
      groupBg: '#1A1B22',
      pieChart1: '#EBF0B1',
      pieChart2: '#EE9023',
      pieChart3: '#ACB9FD',
      pieChart4: '#BDEDDA',
      pieChart5: '#F4B2B6',
      pieChart6: '#AAD6FF',
      pieChart7: '#F9BCE4',
      pieChart8: '#FFD3B4',
      pieChart9: '#A6DCFB',
      pieChart10: '#B3F0F0',
      pieChart11: '#EBF0B1',
      pieChart12: '#D4BCF2',
      pieChart13: '#FDE5AA',
      pieChart14: '#EDB777',
      barChart1: '#DEF0B8',
      barChart2: '#BDEDDA',
      barChart3: '#B3F0F0',
      barChart4: '#F4B2B6',
    },
    text: {
      contrastText: '#1A1A1A',
      toolbarOption: '#595959',
      cardCountText: '#1E2028',
      primary: '#FFFFFF',
      secondary: 'rgba(255, 255, 255, 0.87)',
      disabled: 'rgba(255, 255, 255, 0.6)',
      hint: 'rgba(255, 255, 255, 0.87)',
      placeholder: 'rgba(255, 255, 255, 0.87)',
      inactiveTab: 'rgba(255, 255, 255, 0.7)',
      dropdown: '#fff',
    },
    loginPage: {
      background: '#1A1B22',
      loginFormBorder: '#E5E7EB',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          '&::-webkit-scrollbar-thumb': {
            background: '#CACACA',
          },
        },
        '.ProseMirror pre': {
          backgroundColor: '#1A1B22',
          color: '#F7F7F7',
        },
        '.ProseMirror .wrapperDiv-placeholder': {
          backgroundColor: '#F3F5FF',
          color: '#1A1A1A !important',
        },
        '.ProseMirror .placeholder-decoration': {
          color: '#CACACA',
        },
        '.ProseMirror .selected-cell-decoration': {
          backgroundColor: 'rgba(227, 236, 255, 1)',
          borderColor: ' #272D55',
        },
        '.ProseMirror table': {
          borderColor: '#8B96DE',
        },
        '.tiptap table td.selectedCell': {
          backgroundColor: '#353846 !important',
        },
        '.tiptap table th.selectedCell': {
          backgroundColor: '#353846 !important',
          color: '#FFFFFF',
        },
        '.drag-handle-tiptap': {
          backgroundColor: '#FFFFFF',
        },
        '.menuBarTiptap .is-active': {
          backgroundColor: '#464C64',
        },
        'img.ProseMirror-selectednode': {
          borderColor: '#464C64',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E2028',
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        popupIndicator: {
          color: '#F7F7F7',
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          // backgroundColor: THEME_PALETTE_DARK.other.appBar,
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        root: {
          // color: THEME_PALETTE_DARK.background.default,
        },
        paper: {
          // backgroundColor: '#292C35',
          // color: THEME_PALETTE_DARK.background.default,
          // backgroundColor: THEME_PALETTE_DARK.background.default,
          // boxShadow: `0px 6px 6px ${alpha(THEME_PALETTE_DARK.primary.main, 0.31)}`,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: alpha('#464C64', 0.5),
        },
        colorSecondary: {
          // borderColor: '#84AFEF',
        },
        root: {
          '&:hover': {
            backgroundColor: '#464C64',
          },
          '&:focus': {
            backgroundColor: '#464C64',
          },
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
          '&.job-queue-chip-active': {
            backgroundColor: alpha('#464C64', 0.5),
          },
          '&.job-queue-chip': {
            // backgroundColor: THEME_PALETTE_DARK.other.white,
          },
        },
        label: {
          color: '#F7F7F7',
        },
        deleteIconColorPrimary: {
          color: '#F7F7F7',
          '&:hover': {
            color: '#F7F7F7',
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#F7F7F7 !important',
          color: '#3B3B3B',
          '&:hover': {
            // backgroundColor: `${THEME_PALETTE_DARK.primary.main} !important`,
          },
          '&.list-table-header': {
            backgroundColor: 'transparent !important',
            color: '#FFFFFF !important',
            border: 'none',

            '&svg': {
              color: '#3B3B3B',
              fill: '#3B3B3B',
            },
            '& .MuiCheckbox-root': {
              color: '#F7F7F7',
            },
            '& .Mui-checked': {
              color: '#F7F7F7',
            },
          },
        },

        root: {
          // borderColor: THEME_PALETTE_DARK.secondary.dark,
          // background: THEME_PALETTE_DARK.other.white,
          '&.list-table-cell': {
            borderColor: '#CACACA',
          },
        },
        sizeMedium: {
          '&.list-table-cell': {
            borderColor: '#CACACA',
          },
        },

        sizeSmall: {
          borderColor: '#CACACA',
          '&:hover': {
            backgroundColor: '#353846',
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          borderColor: '#F7F7F7',
          backgroundColor: '#3D4256 !important',
          '& th': {
            color: 'inherit',
            borderTop: '1px solid',
            backgroundColor: 'inherit !important',
          },
          '& .MuiTableSortLabel-root': {
            backgroundColor: 'transparent',
            '& svg': {
              color: '#FFFFFF !important',
              fill: '#FFFFFF !important',
            },
          },
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          color: '#3B3B3B !important',
          fill: '#3B3B3B !important',
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          borderColor: '#CACACA',
        },
      },
    },

    MuiTablePagination: {
      styleOverrides: {
        select: {
          // background: '#FFFFFF',
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
        },
        actions: {
          '& button:focus-visible': {
            outlineColor: '#FFFF',
          },
        },
        toolbar: {
          // background: '#F3F5FF',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        previousNext: {
          background: '#3B3B3B',
        },
        root: {
          '&:focus-visible': {
            outlineColor: '#FFFF !important',
          },
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        barColorPrimary: {
          backgroundColor: '#F7F7F7 !important',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // color: THEME_PALETTE_DARK.text.label,
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {},
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            // color: THEME_PALETTE_DARK.text.label,
          },
          '& .MuiInputLabel-shrink': {
            // color: THEME_PALETTE_DARK.text.label,
          },
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
            {
              borderColor: 'rgba(0, 0, 0, 0.38)',
            },
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          backgroundColor: 'none',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {},

        indicator: {
          // boxShadow: '0px -2px 14px rgba(39, 45, 85, 0.24)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          // color: '#AAACBB',
        },
      },
    },
    // MuiButton: {
    // 	styleOverrides: {
    // 		outlinedSizeLarge: {
    // 			color: '#AECDFC !important',
    // 		},
    // 		containedSecondary: {
    // 			color: '#141A3F !important',
    // 		},
    // 	},
    // },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outlineColor: '#FFFF',
          },
          '&.Mui-SearchPaginationAction': {
            backgroundColor: '#3D4256',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#353846',
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#F7F7F7',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#F7F7F7',
          '&.Mui-focusVisible': {
            backgroundColor: '#D9D9D9',

            '& .MuiSvgIcon-root': {
              backgroundColor: 'white',
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          '&.Mui-checked': {},
        },
        thumb: {
          borderColor: '#F7F7F7 !important',
          '&.Mui-checked': {
            backgroundColor: '#F7F7F7 !important',
          },
        },
        input: {
          '&:focus-visible + .MuiSwitch-thumb': {
            outlineColor: '#FFFF',
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderBottomColor: '#84AFEF',
          '& .MuiListItemIcon-root': {
            color: '#F7F7F7',
          },
          '& .MuiListItemButton-root': {
            '& .list-item-button-hover-actions-right': {
              backgroundImage:
                'linear-gradient(269.82deg, #DDE9FF 68.25%, rgba(200, 222, 255, 0.1) 87.71%)',
            },
            '&:hover': {
              backgroundColor: '#C8DEFF',
            },
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        select: {
          backgroundColor: '#252730',
        },
        icon: {
          color: '#F7F7F7 !important',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          // color: THEME_PALETTE_DARK.text.label,
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#C21919',
          '&.Mui-error': {
            color: '#C21919',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#252730',
          '& fieldset': {
            border: 'none',
          },
          '&.Mui-error': {
            borderColor: '#C21919',
            '& .MuiFormHelperText-root': {
              color: '#C21919',
            },
          },
        },
        input: {
          // color: THEME_PALETTE_DARK.text.primary,
          '&::placeholder': {
            color: 'rgba(255, 255, 255, 0.87) !important',
            opacity: 1,
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#252730',
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#F7F7F7',
        },
        track: {
          backgroundColor: '#F7F7F7',

          borderColor: '#F7F7F7',
        },
        rail: {
          backgroundColor: '#FFFFFF',

          borderColor: '#F7F7F7',
        },
        valueLabel: {
          color: '#FFFFFF',
          background: '#464C64',
        },
        mark: {
          background: '#F7F7F7 !important',
        },
        markLabel: {
          color: '#F7F7F7 !important',
        },
        thumb: {
          '&:hover': {
            boxShadow: `0px 0px 0px 15px ${alpha('#464C64', 0.5)} !important`,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: alpha('#464C64', 0.4),
          '&.permission-accordion': {
            backgroundColor: alpha('#464C64', 0.1),
          },

          '&:before': {
            backgroundColor: 'transparent !important',
          },
          '&.job-queue-accordion': {
            borderColor: '#BCBCBC',
            '& .MuiAccordionDetails-root': {
              backgroundColor: 'transparent',
            },
          },
          '&.job-queue-accordion-read': {
            backgroundColor: '#1E2028',
          },
          '&.job-queue-accordion-unread': {
            backgroundColor: alpha('#464C64', 0.2),
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1B22',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: '#F7F7F7',
          color: '#3B3B3B',
          '& .MuiTypography-root': {
            color: '#3B3B3B',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': '#3D4256',
        },
      },
    },
  },
};

export const darkTheme = DARK_THEME;
export default createTheme(_.merge(_.cloneDeep(baseTheme), DARK_THEME));
